import { Routes, Route } from "react-router-dom";
import MyPage from "../default/pages/MyPage";
import Tickets from "../default/pages/Tickets";
import Quests from "default/pages/QuestGroups";
import HowToUse from "../default/pages/HowToUse";
import News from "../default/pages/News";
import EmailSettings from "../default/pages/EmailSettings";
import Birthday from "../works/yofukashi/pages/Birthday";
import TestTicket from "../works/yofukashi/pages/TestTicket";

import PayPayPolling from "../default/pages/PayPayPolling";
import PayPayCheck from "../default/pages/PayPayCheck";
import PayPayConfirm from "../default/pages/PayPayConfirm";

import PayPayTicketConfirm from "../default/pages/PayPayTicketConfirm";

export default function YofukashiRoutes() {
  return (
    <Routes>
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/mypage" element={<MyPage />} />
      <Route path="/quests" element={<Quests />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/news" element={<News />} />
      <Route path="/email-settings" element={<EmailSettings />} />
      <Route path="/birthday" element={<Birthday />} />
      <Route path="/test-ticket" element={<TestTicket />} />

      <Route path="/paypay/confirm" element={<PayPayConfirm />} />
      <Route path="/paypay/polling" element={<PayPayPolling />} />
      <Route path="/paypay/check" element={<PayPayCheck />} />

      <Route path="/paypay/ticket-confirm" element={<PayPayTicketConfirm />} />
      <Route path="/paypay-polling" element={<PayPayPolling />} />
    </Routes>
  );
}
